module.exports = __webpack_public_path__ + "img/backyard-pond.39431774.jpg";